module.exports = __webpack_public_path__ + "img/firewall-ability.1bb527e.svg";